import {useQuery} from "@tanstack/react-query";
import {useSettings} from "@/context/SettingsContext";
import Hero from "@/components/public/Hero";
import BannerCarousel from "@/components/public/BannerCarousel";
import FeaturedSection from "@/components/public/FeaturedSection";


import CategoryStrip from "@/components/public/CategoryStrip";
import {api} from "@/lib/api";
export default function HomePage(){
 const {settings:s}=useSettings();
 const {data:sections={}}=useQuery({queryKey:["home-public-products"],queryFn:async({signal})=>{
  const [recent,featured]=await Promise.all([
   api.get("/products",{signal,params:{public:true,limit:8,sort:"recent"}}),
   api.get("/products",{signal,params:{public:true,featured:true,limit:8}})
  ]);
  return {recent:recent.data,featured:featured.data};
 },staleTime:120000,retry:1});
 return <div  data-testid="home-page"><Hero/><CategoryStrip/><BannerCarousel/>
  <FeaturedSection kicker={s?.recent_kicker||"É de Tomar da Mão!"} title={s?.recent_title||"Novidades da Mega 20"} products={sections.recent} testId="section-achados"/>
  <FeaturedSection kicker="Nossa seleção" title={s?.featured_title||"Em destaque"} products={sections.featured} linkTo="/produtos?only=featured" testId="section-destaques"/>

 </div>;
}
